<template>
	<div>
		<v-content>
			<v-container fluid>
              <v-flex xs3>
                <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
              </v-flex>
				<v-data-table :headers="headers" :search="search" ref="sortableTable" :items="specStatusList" hide-actions class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">
                        <tr class="sortableRow" id="rows">
                          <td width="5%" class="px-1">
                            <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
                          </td>
						  <td width="65%">{{ props.item.description }}</td>						  
						  <td width="10%" class="text-xs-right">{{ fncCheckBool(props.item.triggers_notification) }}</td>						  
						  <td width="10%" class="text-xs-right"><a @click.prevent="fncEditSpecStatus(props.item.id)"><i class="material-icons">edit</i></a></td>
						  <td width="10%" class="text-xs-right"><a@click.prevent="fncDeleteRfcStatus(props.item.id)"><i class="material-icons">delete_forever</i></a></td>
                        </tr>
					</template>
				</v-data-table>
			</v-container>
		</v-content> 
		<modal></modal>
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';
  import Sortable from 'sortablejs';

  export default {
	name: 'SpecStatusList',
	intRoleEdit: 0,
    data () {
		return {	
			search: '',
            headers: [         
              { text: '', value: 'drag', sortable: false, width: '5%' },
              { text: 'Description', value: 'description', sortable: false, width: '65%' },
              { text: 'Triggers Notification', value: 'triggers_notification', sortable: false, width: '10%' },
              { text: 'Edit', value: 'Edit', sortable: false, width: '10%' },
              { text: 'Delete', value: 'Delete', sortable: false, width: '10%' }
			]
		}
	},
	methods: {
		fncEditSpecStatus( statusId ) {
			this.$store.commit({
				type: 'setObjRfcStatusEdit',
				id: statusId
			});
			var modalDetails = { title: 'Edit Spec Status', component: 'modal-rfc-status-edit', mstate: true, params: {statusId: statusId} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
		fncDeleteRfcStatus( statusId ) {
			var deleteConfirm = confirm('Are you sure you want to remove this status?');
			if(deleteConfirm === true) {
				this.$store.dispatch({
					type: 'fncDeleteSpecStatus',
					statusId: statusId
				})
			}
		},
        fncCheckBool( boolId ) {
		   if( boolId === 1 ) {
				return 'Yes';
			} else {
				return 'No';
			}
        },
        fncReorderRfcStatus({ oldIndex, newIndex }) {          
          this.$store.dispatch({
            type: 'fncReorderRfcStatus',
            start: oldIndex,
            end: newIndex
          });
        }
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'specStatusList',
			'globalModalParams'
		])
	},
	components: {
		Modal
	},
	beforeMount() {
      this.$store.dispatch('fncPopulateSpecStatusList');
	},
    mounted() {
      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          onUpdate: this.fncReorderRfcStatus
        }
      )
    }
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>